<template>
  <div class="status-bar">
    <div class="container-game">
      <div class="status-bar__top">
        <a @click="handleBackClick" class="status-bar__back-link">
          <svg class="icon-arrow-left" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.22452 11.0938H20.1543C20.7177 11.0938 21.1746 11.5048 21.1746 12.0113C21.1746 12.5177 20.7177 12.9288 20.1543 12.9288H5.22452L12.7408 20.4451C12.9079 20.6181 13.0004 20.8499 12.9983 21.0905C12.9962 21.331 12.8997 21.5612 12.7296 21.7313C12.5595 21.9014 12.3294 21.9979 12.0888 22C11.8483 22.0021 11.6165 21.9096 11.4434 21.7424L3.6574 13.9582C3.20215 13.5028 2.92098 12.9022 2.86283 12.2608C2.81135 12.0984 2.81135 11.9241 2.86283 11.7617C2.91788 11.1415 3.18396 10.5396 3.6574 10.0643L11.4434 2.28011C11.5281 2.19247 11.6293 2.12258 11.7413 2.07449C11.8532 2.0264 11.9736 2.00109 12.0954 2.00003C12.2173 1.99898 12.3381 2.02219 12.4508 2.06832C12.5636 2.11446 12.666 2.18259 12.7522 2.26873C12.8383 2.35488 12.9065 2.45732 12.9526 2.57008C12.9987 2.68284 13.0219 2.80366 13.0209 2.92549C13.0198 3.04732 12.9945 3.16771 12.9464 3.27965C12.8983 3.39159 12.8284 3.49284 12.7408 3.57747L5.22452 11.0938Z" />
          </svg>
        </a>
        <div v-if="showProgress && current !== 0" class="status-bar__counter">{{ current }}/{{ total }}</div>
      </div>
      <div v-if="showProgress" class="status-bar__progress">
        <div class="status-bar__progress-bar" :style="{ width: percent + '%' }"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    current: {
      type: Number,
      required: true,
      default: 0
    },
    total: {
      type: Number,
      required: true,
      default: 0
    },
    showProgress: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
    };
  },
  computed: {
    percent() {
      if (!this.total || this.total === 0) return 0;
      return Math.round((this.current / this.total) * 100);
    },
  },
  methods: {
    handleBackClick() {
      // Кнопка "Назад"
      this.sendEventYM('back_click_btn');

      // Эмитим событие для родительского компонента
      this.$emit('back-clicked');
    }
  }
};
</script>

<style scoped lang="scss">
.status-bar {
  --status-bar-color: #F7F6F7;
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 12px;
  width: 100vw;
  z-index: 10;
  background-color: #F7F6F7;

  @media (min-width: $lg) {
    padding-top: 42px;
  }

  &.status-bar--quiz {
    --status-bar-color: #EC001A;
    background-color: #EC001A;

    & .status-bar__back-link,
    & .status-bar__counter {
      color: var(--white);

      & svg {
        fill: var(--white);
      }
    }

    & .status-bar__progress {
      background-color: rgba(255, 255, 255, 0.13);
    }

    & .status-bar__progress-bar {
      background-color: var(--white);
    }
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -19px;
    left: 0;
    width: 100%;
    height: 20px;
    background: linear-gradient(0deg, rgba(236, 0, 26, 0.00) 0%, var(--status-bar-color) 100%);
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  &__back-link {
    flex-shrink: 0;
    width: 24px;
    height: 24px;

    & svg {
      width: 100%;
      height: 100%;
      fill: var(--dark-gray);
    }
  }

  &__counter {
    padding: 12px;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
    border-radius: 1000px;
    background: rgba(255, 255, 255, 0.20);
  }

  &__progress {
    position: relative;
    width: 100%;
    height: 20px;
    background-color: rgba(170, 170, 170, 0.13);
    border-radius: 100px;
    overflow: hidden;

    &-bar {
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border-radius: 100px;
      background-color: var(--red);
      z-index: 1;
    }
  }
}
</style>
